module.exports = __webpack_public_path__ + "static/media/bg15.1d547621.jpg";